import { render, staticRenderFns } from "./PreviewVideo.vue?vue&type=template&id=e8aa5810&scoped=true&"
import script from "./PreviewVideo.vue?vue&type=script&lang=js&"
export * from "./PreviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./PreviewVideo.vue?vue&type=style&index=0&id=e8aa5810&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8aa5810",
  null
  
)

export default component.exports